import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { giftCardsApi, type GiftCardListParams } from '../api/gift-cards-api';

import { giftCardKeys } from './gift-card-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function giftCardListQueryOptions(storeId: string, params: GiftCardListParams) {
  return queryOptions({
    queryKey: giftCardKeys.list(storeId, params),
    queryFn: () => giftCardsApi.list(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useGiftCards(storeId: string, params: GiftCardListParams) {
  return useQuery(giftCardListQueryOptions(storeId, params));
}
